import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonRow,
  IonTitle,
  IonToolbar,
  NavParams,
  PopoverController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { ISTCPaymentAuthorizeResponseDto } from 'src/app/contracts';
import { Auth } from 'src/app/core/common/auth';
import { PaymentService } from 'src/app/services/payment.service';
import { BaseModal } from 'src/app/shared/components/base-modal/base.modal';

@Component({
  templateUrl: 'stc-payment.modal.html',
  styleUrls: ['stc-payment.modal.scss'],
  imports: [FormsModule, NgIf, TranslatePipe, IonLabel, IonItem, IonList, IonContent, IonToolbar, IonHeader, IonTitle, IonFooter, IonButton, IonCol, IonRow],
})
export class STCPaymentModalComponent extends BaseModal {
  public override title: string = 'STC Payment';
  private popoverCtrl = inject(PopoverController);
  private params = inject(NavParams);
  private auth = inject(Auth);
  private payment = inject(PaymentService);

  identifier: string;
  usingWallet = false;
  mobile?: string;
  useRegisteredMobile?: boolean;
  authorizeResponse: ISTCPaymentAuthorizeResponseDto | null = null;
  code?: string;
  constructor() {
    super();
    const params = this.params;

    this.identifier = params.get('identifier');
    this.usingWallet = params.get<boolean>('usingWallet') || false;
  }
  override ngOnInit(): void {
    super.ngOnInit();
  }

  useRegisteredMobileNumber() {
    this.auth.user$.pipe(first()).subscribe(user => {
      this.mobile = user.preferred_username.toString();
    });
  }
  next() {
    if (!this.mobile) {
      this.ui.showError(this.translation.Payment.PleaseEnterYourMobileNumber);
      return;
    }
    if (!this.authorizeResponse) {
      this.payment.authorizeSTCPayment(this.identifier, this.mobile, this.usingWallet).subscribe(response => (this.authorizeResponse = response));
      return;
    }
    if (!this.code || this.code.length < 4) {
      this.ui.showError(this.translation.Payment.PleaseEnterValidVerificationCode);
      return;
    }
    this.payment.confirmSTCPayment(this.code, this.authorizeResponse, this.usingWallet).subscribe(() => {
      this.close(true);
    });
  }
  cancel() {
    this.close();
  }
}
